import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LeftOutlined, FolderOpenOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import Notiflix from "notiflix";
import { connect, useDispatch } from "react-redux";

import {
  DatePicker,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Col,
  Form,
  Table,
  Tooltip,
  Divider,
  Button,
  Anchor,
  Descriptions,
  Spin,
  Statistic,
} from "antd";

//OTHER IMPORTS
import dayjs from "dayjs";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../configurations/configurations.config";
import { rightAction } from "../../../redux/actions";
import CustomButton from "../../../components/custom/CustomButton";

const { Link } = Anchor;
const { Text } = Typography;

const DetailHoliday = (props) => {
  const { userData } = props;
  const { session } = userData;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [holidayDetail, setHolidayDetail] = useState([]);

  useEffect(() => {
    BOM.HasPermission("READ_HOLIDAY") && getDetailById();
  }, []);

  function getDetailById() {
    const params = {
      officeId: state.officeId,
    };
    const url = `${apiConfig.Holidays}/${state.id}`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setIsLoading(false);
        const objList = res;
        setHolidayDetail(objList);

        objList?.status?.value === "Pending for activation" &&
          [cnt.RIGHT_APPROVE_BTN].map((items) => {
            BOM.HasPermission("ACTIVATE_HOLIDAY") && dispatch({ type: items });
          });
        BOM.HasPermission("DELETE_HOLIDAY") && dispatch({ type: cnt.RIGHT_DELETE_BTN });
      }
    });
  }

  function onCancel() {
    navigate("/manage-holidays");
  }

  const items = [
    {
      key: "2",
      label: labelConfig.name,
      children: holidayDetail ? holidayDetail.name : "Not Available",
    },
    {
      key: "3",
      label: labelConfig.fromDate,
      children: holidayDetail ? BOM.DateTime(holidayDetail?.fromDate, "only-date") : "-",
    },
    {
      key: "4",
      label: labelConfig.toDate,
      children: holidayDetail ? BOM.DateTime(holidayDetail?.toDate, "only-date") : "-",
    },

    {
      key: "5",
      label: labelConfig.repaymentScheduledTo,
      children:
        holidayDetail && holidayDetail?.repaymentsRescheduledTo
          ? BOM.DateTime(holidayDetail?.repaymentsRescheduledTo, "only-date")
          : "Next Repayment Date",
    },
  ];

  function handleOnApprove() {
    let action = "Activate ";
    let name = "Holiday ";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + name,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const params = { command: "Activate" };

        let body = {
          method: "POST",
          session,
          params,
        };

        const url = `${apiConfig.Holidays}/${state.id}`;

        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            //STOP LOAD
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.activateHoldayMsg);
            navigate("/manage-holidays");
            //STOP LOAD
            setIsLoading(false);
          }
        });
      },

      function () {
        // No button
      }
    );
  }

  const handleOnDelete = () => {
    let action = "Delete  ";
    let name = "Holiday ";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + name,
      "Yes",
      "No",

      function () {
        setIsLoading(true);

        let body = {
          method: "DELETE",
          session,
        };

        const url = `${apiConfig.Holidays}/${state.id}`;

        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            //STOP LOAD
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteHoldayMsg);
            navigate("/manage-holidays");
            //STOP LOAD
            setIsLoading(false);
          }
        });
      },

      function () {
        // No button
      }
    );
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onApprove={() => handleOnApprove()}
      onDelete={() => handleOnDelete()}
    >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.detailHoliday}
        pageItems={staticConfig.detailHolidayBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical">
            <Row>
              <Col span={24}>
                <Descriptions
                  bordered
                  column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }}
                  style={{ marginTop: 10, marginBottom: 20 }}
                  items={items}
                />
              </Col>
            </Row>

            <Row>
              <Divider />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default DetailHoliday;
